import React, { useEffect, useState } from 'react';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import { decodeToken } from '../../Services/DecodeToken';
import UnauthorizedPopup from './UnauthorizedPopup';
import Cookies from 'js-cookie';
import SessionTimeoutPopup from './SessionTimeoutPopup';

interface Role {
  level: number;
  name: string;
}

interface DecodedToken {
  id: number;
  username: string;
  roles: Role | Role[];
}

interface ProtectedRouteProps {
  requiredAdmin?: boolean;
  minimumRoleLevel?: number;
  allowedRoles?: string[];
  redirectPath?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiredAdmin = false,
  minimumRoleLevel,
  allowedRoles,
  redirectPath,
}) => {
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const [showTimeoutPopup, setShowTimeoutPopup] = useState(false);


  useEffect(() => {
    const validate = async () => {
      const result = await decodeToken(requiredAdmin, minimumRoleLevel, allowedRoles);

      if (result.message === 'Token has expired') {
        setAuthorized(result.authorized);
        setShowTimeoutPopup(true); 
      } else {
        setAuthorized(result.authorized);
        setShowPopup(!result.authorized);
      
      }
      setLoading(false);
     
    };

    validate();
  }, [requiredAdmin, minimumRoleLevel, allowedRoles, navigate]);

  const handleLoginRedirect = () => {
    window.location.href = '/';
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!authorized) {

    if(showTimeoutPopup) {
      return <SessionTimeoutPopup />
    }

    if (redirectPath) {
      return <Navigate to={redirectPath} replace />;
    }

    return (
      <UnauthorizedPopup
        open={showPopup}
        onClose={() => setShowPopup(false)}
        onLoginRedirect={handleLoginRedirect}
      />
  
    );
  }

  return <Outlet />;
};
